import { render } from "./Falcon180bBotSettings.vue?vue&type=template&id=4ea77b9f"
import script from "./Falcon180bBotSettings.vue?vue&type=script&lang=js"
export * from "./Falcon180bBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__